import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import StaticBlockForm from '../../../components/siteadmin/StaticBlockForm/StaticBlockForm';
import Loader from '../../../components/Loader/Loader';

import getStaticInfo from './getStaticInfo.graphql'
import { withQuery } from '../../../hoc/withGraphql';

import s from './StaticBlock.css';

const dynamicFieldMap = {
  carTripTitle1: 'title',
  carTripTitle2: 'title',
  carTripTitle3: 'title',
  carTripContent2: 'content',
  carTripContent3: 'content'
};

const getDynamicFieldValue = (name, staticValue, dynamicData = []) => {
  const valueKey = dynamicFieldMap[name];
  if (!valueKey) return staticValue;

  if (dynamicData && dynamicData.length > 0) {
    return dynamicData.map(item => ({
      language: item.language,
      [valueKey]: item.value || ''
    }));
  }

  try {
    const parsedValue = JSON.parse(staticValue);
    if (Array.isArray(parsedValue) && parsedValue.length > 0) {
      return parsedValue;
    }
  } catch (e) {
  }

  return [{ [valueKey]: staticValue || '', language: 'en' }];
};

const mergeTitleAndContent = (titleData = [], contentData = []) => {
  const merged = titleData.map(titleItem => {
    const matchedContent = contentData.find(
      contentItem => contentItem?.language === titleItem?.language
    );
    return {
      language: titleItem?.language || '',
      title: titleItem?.title || '',
      content: matchedContent?.content || ''
    };
  });

  contentData.forEach(contentItem => {
    const isExists = merged.find(
      item => item?.language === contentItem?.language
    );
    if (!isExists) {
      merged.push({
        language: contentItem?.language || '',
        title: '',
        content: contentItem?.content || ''
      });
    }
  });

  return merged.length > 0 ? merged : [{ language: 'en', title: '', content: '' }];
};

const StaticBlock = (props) => {

  const { data: { getStaticInfo, loading }, title } = props;
  let settingsCollection = {};

  if (loading) {
    return <Loader type={"text"} />;
  } else {

    getStaticInfo?.map((item) => {
      settingsCollection[item.name] = getDynamicFieldValue(
        item.name,
        item.value,
        item.dynamicStaticInfoBlock
      );
    });

    settingsCollection.carTripDetails2 = mergeTitleAndContent(
      settingsCollection.carTripTitle2,
      settingsCollection.carTripContent2
    );
    settingsCollection.carTripDetails3 = mergeTitleAndContent(
      settingsCollection.carTripTitle3,
      settingsCollection.carTripContent3
    );

    return <StaticBlockForm initialValues={settingsCollection} title={title} />;
  }
};

StaticBlock.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getStaticInfo: PropTypes.array,
  })
};

export default compose(
  withStyles(s),
  withQuery(getStaticInfo, {
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only',
    })
  }),
)(StaticBlock);